module.exports = __webpack_public_path__ + "img/bg.38c65c76.svg";